export default "__VITE_ASSET__BaODn7E6__"